import React from 'react';
import { useTranslation } from 'react-i18next';

import FaIconUvilo from '@erikdakoda/ui/components/FaIconUvilo';
import { formatDateTimeISO } from '@erikdakoda/i18n/shared/dateFormat';
import type { Theme, SxProps } from '@mui/material/styles';

const statusIndicatorSx: SxProps<Theme> = {
  ml: 1,
  fontSize: '0.75rem',
  mt: '0.1em',
  zIndex: (theme) => theme.zIndex.modal + 2,
};

export type ProjectIndicatorProps = {
  project: string | null | undefined;
};

export function ProjectIndicator({ project }: ProjectIndicatorProps) {
  'use memo';

  if (!project) return null;
  return (
    <FaIconUvilo
      className="project-indicator"
      icon="chart-gantt"
      sx={statusIndicatorSx}
      title={project}
    />
  );
}

export type ClosedIndicatorProps = {
  closedAt: Date | null | undefined;
};

export function ClosedIndicator({ closedAt }: ClosedIndicatorProps) {
  'use memo';

  const { t } = useTranslation('label-ui');

  if (!closedAt) return null;
  return (
    <FaIconUvilo
      className="closed-indicator"
      icon="door-closed"
      sx={statusIndicatorSx}
      title={
        closedAt
          ? t('closedAt', { date: formatDateTimeISO(closedAt, { hourCycle: 'h23' }) })
          : t('open')
      }
    />
  );
}

export type AnalyzedIndicatorProps = {
  analyzedAt: Date | null | undefined;
};

export function AnalyzedIndicator({ analyzedAt }: AnalyzedIndicatorProps) {
  'use memo';

  const { t } = useTranslation('label-ui');

  if (!analyzedAt) return null;
  return (
    <FaIconUvilo
      className="analyzed-indicator"
      icon="message-bot"
      sx={statusIndicatorSx}
      title={
        analyzedAt
          ? t('analyzedAt', { date: formatDateTimeISO(analyzedAt, { hourCycle: 'h23' }) })
          : t('notAnalyzed')
      }
    />
  );
}
